import { Box, Image, Typography } from "@drone-js/core";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { OneOnboardingImages } from "libs/images/oneOnboarding";
import type { FunctionComponent } from "react";
import { useBatchCompletePageViewModel } from "./useBatchCompletePageViewModel";

export const BatchWelcomeMessage: FunctionComponent = () => {
    const {
        cmsData: {
            complete: { welcomeToAgodaFamilyText, yourPropertyIsListedText },
        },
    } = useStaticDataAtomValue();
    const { publishedListings } = useBatchCompletePageViewModel();

    const hasPublishedListings = publishedListings !== null && publishedListings.length > 0;

    return (
        <Box
            mb="16"
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
            gap="24"
            data-element-name="batch-welcome-message"
            data-testid="batch-welcome-message"
        >
            <Box flexGrow={1}>
                <Box mb="8">
                    <Typography variant="heading-xl" textColor="base.default" data-testid="batch-welcome-title">
                        {welcomeToAgodaFamilyText}
                    </Typography>
                </Box>
                {hasPublishedListings && (
                    <Box mb="16">
                        <Typography variant="body-s" textColor="base.subtle" data-testid="batch-welcome-subtitle">
                            {yourPropertyIsListedText}
                        </Typography>
                    </Box>
                )}
            </Box>
            <Box flexShrink={0} display="none" qM={{ display: "block" }}>
                <Image
                    src={OneOnboardingImages.WelcomeOnboard}
                    alt="Welcome to Agoda"
                    height="90px"
                    data-testid="batch-welcome-image"
                />
            </Box>
        </Box>
    );
};
